// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x5ol","name":"styles_name__25-wk","phone":"styles_phone__28YUE"};